import React from "react";

const ServiceTransport = () => {
  return (
    <>
      <main id="body-content">
        <section className="wide-tb-80">
          <div className="container pos-rel">
            <div className="row align-items-start">
              <div className="col-md-12 col-lg-8">
                <div className="row">
                  <div className="col-md-12 mb-5">
                    <div className="text-left">
                      <img
                        src="images/logistique.jpg"
                        alt=""
                        className="rounded mb-4"
                      />
                      <h4 className="h4-md mb-3 txt-blue fw-7">
                        TRANSPORT & LOGISTIQUE
                      </h4>
                      <p>
                        A l'import comme à l'export, nous assurons toute la
                        chaîne de métiers permettant le mouvement de vos
                        cargaisons de l'enceinte portuaire ou aéroportuaire au
                        lieu de livraison final ainsi que de n'importe quel
                        point du triangle <strong>Cameroun-Tchad-RCA</strong>{" "}
                        vers les points d'embarquement aux ports de Douala et
                        Kribi et aux aéroports internationaux de Douala et
                        Yaoundé NSIMALEN.
                      </p>

                      <h5 className="h5-md mt-5 mb-3 txt-blue fw-7">
                        Notre zone de couverture
                      </h5>
                      <ul className="list-unstyled icons-listing theme-orange mb-0">
                        <li>
                          <i className="icofont-check"></i>Tout le territoire du
                          Cameroun
                        </li>
                        <li>
                          <i className="icofont-check"></i>Douala - Bangui (RCA)
                        </li>
                        <li>
                          <i className="icofont-check"></i>Douala - N'Djamena
                          (Tchad)
                        </li>
                        <li>
                          <i className="icofont-check"></i>Liaisons portuaires :
                          Douala et Kribi
                        </li>
                        <li>
                          <i className="icofont-check"></i>Liaisons
                          aéroportuaires : Douala et Yaoundé NSIMALEN
                        </li>
                      </ul>

                      <h5 className="h5-md mt-5 mb-3 txt-blue fw-7">
                        Nos prestations logistiques
                      </h5>
                      <ul className="list-unstyled icons-listing theme-orange mb-0">
                        <li>
                          <i className="icofont-check"></i>
                          <strong>Transport Import :</strong> De l'enceinte
                          portuaire/aéroportuaire jusqu'au lieu de livraison
                          final
                        </li>
                        <li>
                          <i className="icofont-check"></i>
                          <strong>Transport Export :</strong> Collecte des
                          marchandises et acheminement vers les points
                          d'embarquement
                        </li>
                        <li>
                          <i className="icofont-check"></i>Transport de charges
                          lourdes et volumineuses
                        </li>
                        <li>
                          <i className="icofont-check"></i>Transport de
                          conteneurs 20' et 40'
                        </li>
                        <li>
                          <i className="icofont-check"></i>Transport régional
                          (Cameroun, Tchad, RCA)
                        </li>
                        <li>
                          <i className="icofont-check"></i>Gestion de flotte et
                          optimisation des trajets
                        </li>
                        <li>
                          <i className="icofont-check"></i>Suivi GPS en temps
                          réel de vos marchandises
                        </li>
                        <li>
                          <i className="icofont-check"></i>Entreposage
                        </li>
                        <li>
                          <i className="icofont-check"></i>Manutention
                        </li>
                      </ul>

                      <h5 className="h5-md mt-5 mb-3 txt-blue fw-7">
                        Nos avantages
                      </h5>
                      <ul className="list-unstyled icons-listing theme-orange mb-0">
                        <li>
                          <i className="icofont-check"></i>Flotte moderne et
                          bien entretenue
                        </li>
                        <li>
                          <i className="icofont-check"></i>Chauffeurs
                          expérimentés et formés
                        </li>
                        <li>
                          <i className="icofont-check"></i>Couverture
                          d'assurance complète
                        </li>
                        <li>
                          <i className="icofont-check"></i>Respect des délais de
                          livraison
                        </li>
                        <li>
                          <i className="icofont-check"></i>Service client
                          réactif 24/7
                        </li>
                        <li>
                          <i className="icofont-check"></i>Solutions sur mesure
                          adaptées à vos besoins
                        </li>
                        <li>
                          <i className="icofont-check"></i>Optimisation des
                          coûts
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-4">
                <aside className="sidebar-spacer row">
                  <div className="sidebar-primary col-lg-12 col-md-6">
                    <div className="widget-wrap text-center bg-sky-blue rounded py-5">
                      <div className="mb-2">
                        <i className="icofont-headphone-alt icofont-4x"></i>
                      </div>
                      <h3 className="h3-md fw-5 txt-orange mb-4">
                        Besoin d'aide?
                      </h3>
                      <p>
                        Contactez notre
                        <br /> support technique 24/7
                      </p>
                      <a
                        href="/contact"
                        className="btn-theme bg-secondary mt-3"
                      >
                        Contacter <i className="icofont-rounded-right"></i>
                      </a>
                    </div>
                  </div>
                  <div className="sidebar-secondary col-lg-12 col-md-6">
                    <div className="widget-wrap">
                      <h3 className="h3-md fw-7 mb-4">Nos services</h3>
                      <div className="blog-list-categories">
                        <ul className="list-unstyled">
                          <li>
                            <a href="/servicedouane">Douane & Transit</a>
                          </li>
                          <li className="active">
                            <a href="/servicetransport">
                              Transport & Logistique
                            </a>
                          </li>
                          <li>
                            <a href="/servicepetrolier">
                              Transport Produits Pétroliers
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="widget-wrap">
                      <h3 className="h3-md fw-7 mb-4">Notre Photothèque</h3>
                      <ul className="photo-thumbs">
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-1.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-1.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-2.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-2.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-3.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-3.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-4.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-4.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-5.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-5.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-6.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-6.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-7.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-7.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-8.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-8.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/images/portfolio/original-images/3col-9.jpg"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="/images/portfolio/original-images/3col-9.jpg"
                              alt="image-1"
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};
export default ServiceTransport;
